import { getFiliations, getTreeFiliations } from "@/api/filiations";
import Vue from "vue";

// Sort
function sortArray (array) {
  array.sort((a, b) => {
    if (a.children?.length > 0 && b.children?.length === 0) {
      return -1
    }
    return 0
  })
  return array
}

// Рекурсия
function recursionArrayObject (array) {
  sortArray(array)
  for (let subObj of Object.values(array)){
    if (subObj.children?.length) {
      sortArray(subObj.children)
      recursionArrayObject(subObj.children)
    }
  }
  return array
}


export default {
  namespaced: true,
  state: {
    filiations: [],
    treeFiliations: [],
    treeFiliationsLoading: true,
  },
  actions: {
    getFiliations({ commit }) {
      getFiliations().then((res) => {
        const data = [...res.data].map(item => {
          item.isActive = false
          return item
        })
        commit("SET_FILIATIONS", data)
      });
    },
    getTreeFiliations({ commit }, params) {
      commit("SET_TREE_FILIATIONS_LOADING", true);

      params.trashed = params?.trashed || null
      getTreeFiliations(params)
        .then((res) => {
          const data = recursionArrayObject(res)
          commit("SET_TREE_FILIATIONS", data);
        })
        .finally(() => commit("SET_TREE_FILIATIONS_LOADING", false));
    },

    clearTree({ commit }) {
      commit("CLEAR_TREE_FILIATIONS")
    },

    setActiveEl({ commit }, id) {
      commit("SET_IS_ACTIVE_TREE", id)
    }
  },
  mutations: {
    SET_FILIATIONS(state, filiations) {
      state.filiations = filiations;
    },
    ADD_FILIATIONS(state, filiation) {
      state.filiations.push(filiation);
    },
    DELETE_FILIATIONS(state, filId) {
      state.filiations = state.filiations.filter((dep) => dep.id !== filId);
    },
    SET_TREE_FILIATIONS(state, tree) {
      state.treeFiliations = tree;
    },
    SET_TREE_FILIATIONS_LOADING(state, loading) {
      state.treeFiliationsLoading = loading;
    },
    UPDATE_FILIATION(state, filiation) {
      const filIndex = state.filiations.findIndex(
        (fil) => fil.id === filiation.id
      );
      if (filIndex !== -1) Vue.set(state.filiations, filIndex, filiation);
    },
    CLEAR_TREE_FILIATIONS (state) {
      state.treeFiliations = []
    }
  },
  getters: {
    getFiliationById(state) {
      return (id) => state.filiations.find((dep) => dep.id === id);
    },
    getFiliationNameById(state) {
      return (id) => state.filiations.find((dep) => dep.id === id)?.name || "";
    },
    getParentFiliationById(state) {
      return (parentId) =>
        state.filiations.find((dep) => dep.id === parentId) || null;
    },
    treeFiliations(state) {
      return state.treeFiliations
    }
  },
};
